import { TApplicationState } from '../../types/redux';

export const houseByIdSelector = (id?: number) => (state: TApplicationState) => {
  return state.newbuilding.houses.find(house => house.houseId === id);
};
